import { useMemo } from "react";
import Flx from "../../../components/layout/Flx";
import { useMediaQuery, useTheme } from "@mui/material";

const FlxGrid = ({
  children,
  width = "300px",
  grow = 1,
  sx,
  gap = 1,
  className,
  suppressAutoMobile = false,
  lastItemSpan = 1, // NEW (default = 2 columns)
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const styles = useMemo(() => {
    const isSingleColumn = isMobile && !suppressAutoMobile;

    return {
      display: "grid",
      gridTemplateColumns: isSingleColumn
        ? "1fr"
        : `repeat(auto-fit, minmax(${width}, ${grow}fr))`,
      gap: gap,

      // make last child span columns (only when not single column)
      ...(!isSingleColumn && lastItemSpan > 1
        ? {
            "& > *:last-child": {
              gridColumn: `span ${lastItemSpan}`,
            },
          }
        : {}),

      ...sx,
    };
  }, [sx, width, grow, gap, isMobile, suppressAutoMobile, lastItemSpan]);

  return (
    <Flx wrap sx={styles} className={className}>
      {children}
    </Flx>
  );
};

export default FlxGrid;
